import { render, staticRenderFns } from "./CoreFinanceData.vue?vue&type=template&id=4a2e2a7c&scoped=true&"
import script from "./CoreFinanceData.vue?vue&type=script&lang=js&"
export * from "./CoreFinanceData.vue?vue&type=script&lang=js&"
import style0 from "./CoreFinanceData.vue?vue&type=style&index=0&id=4a2e2a7c&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a2e2a7c",
  null
  
)

export default component.exports